import { render, staticRenderFns } from "./Mobile.vue?vue&type=template&id=5f81d5b7&scoped=true&"
import script from "./Mobile.vue?vue&type=script&lang=js&"
export * from "./Mobile.vue?vue&type=script&lang=js&"
import style0 from "./Mobile.vue?vue&type=style&index=0&id=5f81d5b7&lang=scss&scoped=true&"
import style1 from "./Mobile.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./Mobile.vue?vue&type=style&index=2&id=5f81d5b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f81d5b7",
  null
  
)

export default component.exports